import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Icon, IconButton, Tooltip } from "@mui/material";
import { motion } from "framer-motion";
import { memo, useState } from "react";
import { useEliminarInformadoMutation, useObtenerInformeEntregadoGobiernoMutation, useObtenerPDFLiquidacionMutation, useObtenerPDFRechazadoMutation } from "@/redux/api/informeApi";
import { IInforme, estadoGeneralCarrito, estadoGeneralInforme } from "@/redux/models";
import { useAppSelector } from "@/redux/store";
import { useTablaCarpetaContext } from "../../logics/TablaCarritoProvider";

const getColorByEstadoInforme = (estado: estadoGeneralInforme): any => {
    let color = 'success'

    switch (estado) {
        case estadoGeneralInforme['Pendiente']:
            color = 'warning'
            break;
        case estadoGeneralInforme['En proceso']:
            color = 'error'
            break;
        case estadoGeneralInforme['Informado']:
            color = 'success'
            break;
    }

    return color
}

export const EstadosInformeCell = ({ informe }: { informe: IInforme }) => {

    const [obtenerPdfLinkLiq] = useObtenerPDFLiquidacionMutation()
    const [obtenerRechazadoPdfLink] = useObtenerPDFRechazadoMutation()
    const [obtenerInformeEntregadoGobiernoLink] = useObtenerInformeEntregadoGobiernoMutation()
    const [eliminarInformado] = useEliminarInformadoMutation()
    const currentUser = useAppSelector(state => state.userState.user)
    const isAdmin = currentUser?.role === 'admin' || currentUser?.role === 'dev'

    const { context } = useTablaCarpetaContext();

    const [openConfirm, setOpenConfirm] = useState(false);


    async function handleObtenerInformeEntregadoGobierno(id: number) {
        const response = await obtenerInformeEntregadoGobiernoLink(id).unwrap();
        return response.data;
    }

    async function handleObtenerPdfLiquidacion(id: number): Promise<any> {
        const result = await obtenerPdfLinkLiq(id).unwrap();
        return result.data;
    }

    async function handleObtenerPdfDelRechazado(id: number): Promise<any> {
        const result = await obtenerRechazadoPdfLink(id).unwrap();
        return result.data;
    }


    const handleClickDeshacer = () => setOpenConfirm(true);

    const handleConfirmDeshacer = async () => {

        if (informe.estadoGeneral === estadoGeneralInforme['Informado']) {
            await eliminarInformado(informe.id).unwrap().then(() => {
                const carpeta = context.carpetas.find(c => c.idCarrito === informe.idCarrito)
                if (!carpeta) {
                    console.error('Carpeta no encontrada');
                    return;
                }
                context.modificarInforme({...informe, estadoGeneral: estadoGeneralInforme['En proceso'] })
                context.modificarCarpeta({ ...carpeta, estadoGeneral: estadoGeneralCarrito['En proceso'] })
            })
            setOpenConfirm(false);

        }
    };

    const handleCancelDeshacer = () => setOpenConfirm(false)

    return (<>
        {
            informe.estadoGeneral === estadoGeneralInforme['Informado'] ? (
                <>
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <Chip
                            icon={<Icon>get_app</Icon>}
                            sx={{ m: '2px' }}
                            size="small"
                            label={estadoGeneralInforme[informe.estadoGeneral]}
                            color={getColorByEstadoInforme(informe.estadoGeneral)}
                            onClick={async () => {
                                const informeLink = await handleObtenerInformeEntregadoGobierno(informe.id);
                                if (informeLink != null)
                                    window.open(informeLink, "_blank");
                            }}
                            onDelete={isAdmin ? () => { } : undefined}
                            deleteIcon={isAdmin ? 
                                <motion.div
                                    whileHover={{ scale: 0.92 }}
                                    whileTap={{ scale: 0.95 }}
                                    style={{ display: 'inline-flex' }}
                                >
                                    <Tooltip title="Deshacer informe">
                                        <IconButton
                                            size="small"
                                            sx={{
                                                p: '3px',
                                                height: 24,
                                                width: 24,
                                                boxShadow: 1,
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: 2,
                                                }
                                            }}
                                            onClick={() => handleClickDeshacer()}
                                        >
                                            <Icon fontSize="small" color="error">undo</Icon>
                                        </IconButton>
                                    </Tooltip>
                                </motion.div>
                                : undefined
                            }
                        />

                        {isAdmin && (
                            <Dialog
                                open={openConfirm}
                                onClose={handleCancelDeshacer}
                            >
                                <DialogTitle>Confirmar acción</DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        ¿Estás seguro que deseas deshacer el informado?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCancelDeshacer} color="primary">
                                        Cancelar
                                    </Button>
                                    <Button onClick={handleConfirmDeshacer} color="error">
                                        Deshacer
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        )}
                    </Box>

                </>
            ) : (
                <Chip
                    sx={{ m: '2px' }}
                    size="small"
                    label={estadoGeneralInforme[informe.estadoGeneral]}
                    color={getColorByEstadoInforme(informe.estadoGeneral)}
                />
            )
        }

        {
            informe.liquidado && (
                <Chip
                    icon={<Icon sx={{ color: 'white !important' }}>get_app</Icon>}
                    sx={{
                        m: '2px', backgroundColor: '#4b45b9d9', color: 'white',
                        ':hover': {
                            backgroundColor: '#3b386b',
                            color: 'white'
                        }
                    }}
                    size="small"
                    label={'Liquidado'}
                    onClick={async () => {
                        const pdfLink = await handleObtenerPdfLiquidacion(informe.id);
                        if (pdfLink != null)
                            window.open(pdfLink, "_blank");
                    }}
                />
            )
        }
        {
            informe.rejected && (
                <Chip
                    icon={<Icon sx={{ color: 'white !important' }}>get_app</Icon>}
                    sx={{
                        m: '2px', backgroundColor: '#ff0000', color: 'white',
                        ':hover': {
                            backgroundColor: '#990101',
                            color: 'white'
                        }
                    }}
                    size="small"
                    label="Rechazado"
                    onClick={async () => {
                        const pdfLink = await handleObtenerPdfDelRechazado(informe.id);
                        if (pdfLink != null)
                            window.open(pdfLink, "_blank");
                    }}
                />
            )
        }
    </>);
}

export default memo(EstadosInformeCell, (prev, next) =>
    prev.informe.estadoGeneral === next.informe.estadoGeneral &&
    prev.informe.liquidado === next.informe.liquidado)
